import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { FounderStory } from './sections/FounderStory';
import { JourneySection } from './sections/JourneySection';
import { MissionSection } from './sections/MissionSection';
import { ProductShowcase } from './sections/ProductShowcase';
import { TestimonialSection } from './sections/TestimonialSection';
import { CTASection } from './sections/CTASection';
import { Footer } from './sections/Footer';
import { StickyWebshopPromo } from './StickyWebshopPromo';
import { MobileStoreButton } from './MobileStoreButton';
export const FRZNAdvertorial = () => {
  return <div className="w-full bg-white text-black font-sans" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="bg-black text-white text-xs text-center py-1" data-id="element-3">
          Advertisement
        </div>
        <HeroSection data-id="element-4" />
        <FounderStory data-id="element-5" />
        <JourneySection data-id="element-6" />
        <MissionSection data-id="element-7" />
        <ProductShowcase data-id="element-8" />
        <TestimonialSection data-id="element-9" />
        <CTASection data-id="element-10" />
        <Footer data-id="element-11" />
      </div>
      <StickyWebshopPromo data-id="element-12" />
      <MobileStoreButton data-id="element-13" />
    </div>;
};